import React, { useState } from 'react';


import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import Fab from '@mui/material/Fab';
import EditIcon from '@mui/icons-material/Edit';
import IconButton from '@mui/material/IconButton';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { red } from '@mui/material/colors';

import DistributionsCollapse from './DistributionsCollapse';
import EntryDialog from './EntryDialog';
import { Stack, Typography } from '@mui/material';
import axiosInstance from '../../api/axiosInstance';

export default function EntryRow({ entry, accounts, onUpdate }) {
    const [collapseOpen, setCollapseOpen] = React.useState(false);
    const [isDialogOpen, setDialogOpen] = React.useState(false);

    const VAT_RATES = {
        NOR: '20 %',
        MID: '10 %',
        RED: '5,5 %',
        SPE: '2,1 %',
        NUL: '0 %',
        ND: 'indéterminé',
    };

    const handleDialogClose = () => setDialogOpen(false);
    const handleDialogOpen = () => setDialogOpen(true);

    const handleUpdate = async (updatedEntry) => {
        try {
            // Mets à jour l'entrée dans la base de données
            console.log(updatedEntry);
            await axiosInstance.put(`api/entries/${updatedEntry.id}/`, updatedEntry);
            onUpdate(updatedEntry); // Mets à jour l'état global dans EntryTable
        } catch (error) {
            console.error("Erreur lors de la mise à jour de la transaction :", error);
        } finally {
            setDialogOpen(false); // Ferme le dialogue après la mise à jour
        }
    };

    return (
        <>
            <TableRow>
                <TableCell>
                    {entry.type === 'EXP' && <IconButton
                        aria-label="expand row"
                        size="small"
                        onClick={() => setCollapseOpen(!collapseOpen)}
                    >
                        {collapseOpen ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                    </IconButton>
                    }
                </TableCell>
                <TableCell component="th" scope="row">{new Date(entry.date).toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit', year: 'numeric' }).replace('.', '')}</TableCell>
                <TableCell align="left" style={{ cursor: 'pointer' }}>
                    <Fab onClick={handleDialogOpen} size="small" color="secondary.light" aria-label="edit" sx={{ margin: 2 }}>
                        <EditIcon />
                    </Fab>
                    {entry.label}
                </TableCell>
                <EntryDialog
                    open={isDialogOpen}
                    onUpdate={handleUpdate}
                    onClose={handleDialogClose}
                    entry={entry} />
                <TableCell sx={{
                    color: entry.type === 'EXP' ? red[500] : 'inherit'
                }} align="right">
                    <Stack>
                        <Typography variant='body1'>{entry.amount.toLocaleString('fr-FR', {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                        })}</Typography>
                        <Typography variant='caption'>TVA : {VAT_RATES[entry.vat_rate]}</Typography>
                    </Stack>
                </TableCell>
            </TableRow>
            {entry.type === 'EXP' && <DistributionsCollapse open={collapseOpen} entry={entry} accounts={accounts} />}
        </>
    );
};